import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appControlTemplate]'
})
export class FormControlTemplatesDirective {

  @Input('appControlTemplate') name: string;
  constructor(public template: TemplateRef<any>) { }

}
